// Detect whether a table cell's text represents a number, and extract its value.
// Used by the cell-selection feature to compute Sum / Avg / Min / Max.
// Intentionally strict: alphanumeric codes (HSN, invoice #) must NOT parse as numeric.

const CURRENCY_PREFIX = /^\s*(?:₹|\$|€|£|Rs\.?|INR|USD)\s*/i;
const UNIT_SUFFIX     = /\s*(?:%|kg|g|mt|ltr|nos|pcs|units)\s*$/i;
const ACCOUNTING_NEG  = /^\((.+)\)$/;
const STRICT_NUMBER   = /^-?\d+(?:\.\d+)?$/;

export function parseNumericCell(raw) {
  if (raw == null) return { value: null, isNumeric: false };
  let s = String(raw).replace(/\u00A0/g, " ").trim();
  if (s === "") return { value: null, isNumeric: false };

  s = s.replace(CURRENCY_PREFIX, "");
  s = s.replace(UNIT_SUFFIX, "");

  const paren = s.match(ACCOUNTING_NEG);
  if (paren) s = "-" + paren[1].replace(CURRENCY_PREFIX, "").trim();

  s = s.replace(/,/g, "");

  if (STRICT_NUMBER.test(s)) {
    return { value: parseFloat(s), isNumeric: true };
  }
  return { value: null, isNumeric: false };
}
